/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SaveWorkflowStageRequest model module.
 * @module model/SaveWorkflowStageRequest
 * @version V1
 */
class SaveWorkflowStageRequest {
    /**
     * Constructs a new <code>SaveWorkflowStageRequest</code>.
     * @alias module:model/SaveWorkflowStageRequest
     * @param name {String} 
     * @param senderUserId {Number} 
     * @param subjectLine {String} 
     * @param message {String} 
     */
    constructor(name, senderUserId, subjectLine, message) { 
        
        SaveWorkflowStageRequest.initialize(this, name, senderUserId, subjectLine, message);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name, senderUserId, subjectLine, message) { 
        obj['name'] = name;
        obj['senderUserId'] = senderUserId;
        obj['subjectLine'] = subjectLine;
        obj['message'] = message;
    }

    /**
     * Constructs a <code>SaveWorkflowStageRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SaveWorkflowStageRequest} obj Optional instance to populate.
     * @return {module:model/SaveWorkflowStageRequest} The populated <code>SaveWorkflowStageRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SaveWorkflowStageRequest();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('senderUserId')) {
                obj['senderUserId'] = ApiClient.convertToType(data['senderUserId'], 'Number');
            }
            if (data.hasOwnProperty('templateId')) {
                obj['templateId'] = ApiClient.convertToType(data['templateId'], 'Number');
            }
            if (data.hasOwnProperty('subjectLine')) {
                obj['subjectLine'] = ApiClient.convertToType(data['subjectLine'], 'String');
            }
            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
            if (data.hasOwnProperty('bccUserIds')) {
                obj['bccUserIds'] = ApiClient.convertToType(data['bccUserIds'], ['Number']);
            }
            if (data.hasOwnProperty('checklistId')) {
                obj['checklistId'] = ApiClient.convertToType(data['checklistId'], 'Number');
            }
            if (data.hasOwnProperty('firstApproverApprovesStage')) {
                obj['firstApproverApprovesStage'] = ApiClient.convertToType(data['firstApproverApprovesStage'], 'Boolean');
            }
            if (data.hasOwnProperty('approvalConfirmationEmailEnabled')) {
                obj['approvalConfirmationEmailEnabled'] = ApiClient.convertToType(data['approvalConfirmationEmailEnabled'], 'Boolean');
            }
            if (data.hasOwnProperty('approvalConfirmationTemplateId')) {
                obj['approvalConfirmationTemplateId'] = ApiClient.convertToType(data['approvalConfirmationTemplateId'], 'Number');
            }
            if (data.hasOwnProperty('proofAllowDownload')) {
                obj['proofAllowDownload'] = ApiClient.convertToType(data['proofAllowDownload'], 'Boolean');
            }
            if (data.hasOwnProperty('proofAllowApproveIndividualFiles')) {
                obj['proofAllowApproveIndividualFiles'] = ApiClient.convertToType(data['proofAllowApproveIndividualFiles'], 'Boolean');
            }
            if (data.hasOwnProperty('proofAllowViewAllComments')) {
                obj['proofAllowViewAllComments'] = ApiClient.convertToType(data['proofAllowViewAllComments'], 'Boolean');
            }
            if (data.hasOwnProperty('proofAllowApproveWithChanges')) {
                obj['proofAllowApproveWithChanges'] = ApiClient.convertToType(data['proofAllowApproveWithChanges'], 'Boolean');
            }
            if (data.hasOwnProperty('proofLimitVersionVisibility')) {
                obj['proofLimitVersionVisibility'] = ApiClient.convertToType(data['proofLimitVersionVisibility'], 'Boolean');
            }
            if (data.hasOwnProperty('proofBlockCommentingAfterProofDecision')) {
                obj['proofBlockCommentingAfterProofDecision'] = ApiClient.convertToType(data['proofBlockCommentingAfterProofDecision'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SaveWorkflowStageRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SaveWorkflowStageRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SaveWorkflowStageRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['subjectLine'] && !(typeof data['subjectLine'] === 'string' || data['subjectLine'] instanceof String)) {
            throw new Error("Expected the field `subjectLine` to be a primitive type in the JSON string but got " + data['subjectLine']);
        }
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['bccUserIds'])) {
            throw new Error("Expected the field `bccUserIds` to be an array in the JSON data but got " + data['bccUserIds']);
        }

        return true;
    }


}

SaveWorkflowStageRequest.RequiredProperties = ["name", "senderUserId", "subjectLine", "message"];

/**
 * @member {String} name
 */
SaveWorkflowStageRequest.prototype['name'] = undefined;

/**
 * @member {Number} senderUserId
 */
SaveWorkflowStageRequest.prototype['senderUserId'] = undefined;

/**
 * @member {Number} templateId
 */
SaveWorkflowStageRequest.prototype['templateId'] = undefined;

/**
 * @member {String} subjectLine
 */
SaveWorkflowStageRequest.prototype['subjectLine'] = undefined;

/**
 * @member {String} message
 */
SaveWorkflowStageRequest.prototype['message'] = undefined;

/**
 * @member {Array.<Number>} bccUserIds
 */
SaveWorkflowStageRequest.prototype['bccUserIds'] = undefined;

/**
 * @member {Number} checklistId
 */
SaveWorkflowStageRequest.prototype['checklistId'] = undefined;

/**
 * @member {Boolean} firstApproverApprovesStage
 */
SaveWorkflowStageRequest.prototype['firstApproverApprovesStage'] = undefined;

/**
 * @member {Boolean} approvalConfirmationEmailEnabled
 */
SaveWorkflowStageRequest.prototype['approvalConfirmationEmailEnabled'] = undefined;

/**
 * @member {Number} approvalConfirmationTemplateId
 */
SaveWorkflowStageRequest.prototype['approvalConfirmationTemplateId'] = undefined;

/**
 * @member {Boolean} proofAllowDownload
 */
SaveWorkflowStageRequest.prototype['proofAllowDownload'] = undefined;

/**
 * @member {Boolean} proofAllowApproveIndividualFiles
 */
SaveWorkflowStageRequest.prototype['proofAllowApproveIndividualFiles'] = undefined;

/**
 * @member {Boolean} proofAllowViewAllComments
 */
SaveWorkflowStageRequest.prototype['proofAllowViewAllComments'] = undefined;

/**
 * @member {Boolean} proofAllowApproveWithChanges
 */
SaveWorkflowStageRequest.prototype['proofAllowApproveWithChanges'] = undefined;

/**
 * @member {Boolean} proofLimitVersionVisibility
 */
SaveWorkflowStageRequest.prototype['proofLimitVersionVisibility'] = undefined;

/**
 * @member {Boolean} proofBlockCommentingAfterProofDecision
 */
SaveWorkflowStageRequest.prototype['proofBlockCommentingAfterProofDecision'] = undefined;




export default SaveWorkflowStageRequest;

